export default function checkIsTicketTypeNotOnSale({
  ticketType,
  isCanceled = false,
  isOnSale = false,
  isScheduled = false,
  hasInvalidReference = false,
}) {
  if (!ticketType) {
    return true;
  }

  const isSoldOut = ticketType.isSoldOut;
  const isAvailable = ticketType.availabilityStatus === 'available';

  return (
    (!isSoldOut && !isCanceled && isAvailable && !isOnSale && !isScheduled) || hasInvalidReference
  );
}
